import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';

export function getDescuentoListSuccess(descuento) {
  return {type: types.LOAD_DESCUENTO_LIST_SUCCESS, descuento};
}

export function getDescuentoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().DescuentoApi.getDescuentoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(descuento => {                  
                  dispatch(getDescuentoListSuccess(descuento));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getDescuentoSuccess(catalogo) {
  return {type: types.LOAD_DESCUENTO_SUCCESS, catalogo};
}

export function getDescuento(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().DescuentoApi.getDescuento(id, token).then(descuento => {   
        dispatch(getDescuentoSuccess(descuento));
        return descuento;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(descuento) {
  return {type: types.SAVE_DESCUENTO_SUCCESS, descuento};
}


export function save(descuento, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().DescuentoApi.save(descuento, token).then(descuentoGuardado => {   
    dispatch(saveSuccess(descuentoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getDescuentoComboSuccess(datos) {
  return {type: types.GET_DESCUENTOS_COMBO_SUCCESS, datos};
}

export function getDescuentoCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().DescuentoApi.getDescuentoCombo(token).then(datos => {   
        
      dispatch(getDescuentoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(descuento) {
  return {type: types.BORRAR_DESCUENTO_SUCCESS, descuento};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().DescuentoApi.borrar(id, token ).then(descuento => {
               
                  dispatch(borrarSuccess(descuento));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getCodigosList(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().DescuentoApi.getCodigosList(id, token ).then(cupones => {
                  dispatch(sinReducerSuccess(cupones));
                  return cupones;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(descuento) {
  return {type: types.ACTIVAR_DESCUENTO_SUCCESS, descuento};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().DescuentoApi.activar(id, token).then(descuento => {
               
                  dispatch(activarSuccess(descuento));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_DESCUENTO, filtro};
}



